export const DE = (props: React.ComponentPropsWithoutRef<'svg'>) => (
  <svg
    aria-hidden="true"
    fill="none"
    height="24"
    viewBox="0 0 32 24"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9104_11063)">
      <path d="M0 16H32V24H0V16Z" fill="#FFCC00" />
      <path d="M0 0H32V8H0V0Z" fill="#000001" />
      <path d="M0 8H32V16H0V8Z" fill="#FF0000" />
    </g>
    <defs>
      <clipPath id="clip0_9104_11063">
        <rect fill="white" height="24" width="32" />
      </clipPath>
    </defs>
  </svg>
)
